import FieldDefs from './AdsLinksFieldDefs'
import {doLangFields} from '../../lib/ks-tools'
import AdsSelector from "./mixins/Selector";

export default {
    template: `<div><slot v-bind="self"/></div>`,
    mixins: [AdsSelector],
    data() {
        return {
            fields: doLangFields(this, "lang.report.adslinks.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'links',
                    direction: 'desc'
                }
            ],
            moreParams: {},
            viewMode: '&view=links',
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
